import React, {Component} from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from "react-redux"
// import CheckBox from './CheckBox'
import CheckboxGroup from './forms/CheckboxGroup'
import Modal from 'react-responsive-modal';

import agent from '../agent'
import { store, history } from '../store/configureStore'

const validate = {
	roles: value => value && value.length ? undefined : 'Please select a role',
}

const ErrorMessage = ({message, flag, token}) => {
	// const url = 'https://casting.auditionmagic.com/ForgotPassword.aspx'
	const url = '/forgotpassword' //forgotpassword
	
	if (flag) {
		return (<div className="margin-bottom-here">Ohranger
			</div>)
	} else {
		return (<div className="margin-bottom-here">{ message }</div>)
	}
}

class RolesPage extends Component {
	state = {
		selected_role: null,
		available_roles: [],
		loading: true
	}

	componentWillMount() {
		window.localStorage.setItem('_errorMessage', '')
		window.localStorage.setItem('_showModal', false)
		console.log('componentWillMount-Roles', this.props)
		if ((typeof this.props.aud != "undefined") && (typeof this.props.proj != "undefined")) {
			const audition = this.props.aud.find(k => k.artist_id === this.props.artist.id && k.project_id === this.props.proj.id)
			if (typeof audition != "undefined") {
				const role = this.props.roles.find(k => k.id === audition.role_id)
				this.setState({ selected_role: role })
			} else {
				console.log('falsebyfalse2')	
			}
		} else {
			console.log('falsebyfalse')
		}
	}

	async componentDidMount() {
		if (this.props.artist && this.props.project) {
			let roles = await agent.Project.getRolesForArtist(this.props.project.id, this.props.artist.id)
			this.setState({ available_roles: roles.roles, loading: false, selected_role: roles.applied })
		} else {
			this.setState({ loading: false })
		}
	}

	componentWillUnmount() {
		
	}

	async submit (values, dispatch, props) {
		if (!props.publicToken) { return props.onSubmit(props.handleSubmit) }

		let role_ids = Array.from(new Set(values.roles))

		const data = {
			id: props.artist.id,
			project_id: props.project.id,
			role_ids: role_ids
		}
		const auditions = await agent.Project.createAudition(data).then(res => res.auditions).catch(error => error.response.body)
		if (auditions.message) {
			window.localStorage.setItem('_errorMessage', 'The limit for this project has been reached, please contact the client directly.')
		 	window.localStorage.setItem('_showModal', true)
		}
		const auditionIds = auditions.map(audition => audition.id)
		let artist_payload = {
			project_id: props.project.id,
			artist_id: props.artist.id
		}
		if (values.roles && values.roles.length) {
			artist_payload.roles = values.roles
		}
		await dispatch(change('checkinWizard', 'audition_ids', auditionIds))
		window.localStorage.setItem('role_ids', values.roles)

		if (typeof props.handleSave === "function") {
			props.handleSave(values);
		}

		return props.onSubmit(props.handleSubmit)
		
	}
  
	onCloseModal = () => {
		// this.setState({ showModal: false });
		window.localStorage.removeItem('_errorMessage');
		window.localStorage.removeItem('_showModal');

		if (this.props.location == null || this.props.location.search == null) {
			window.localStorage.clear();
			history.push({pathname: '/'});
		} else {
				history.push({
			      pathname: '/artist/dashboard',
			      search: this.props.location.search,
			      state: this.props.location.state
		    })
		}
	}

	render() {
	const { handleSubmit, previousPage, nextPage, pristine, submitting, roles, publicToken, location, aud } = this.props
	const {loading, available_roles, selected_role } = this.state
	const errorMessage = selected_role == null ? 'No roles available' : (window.localStorage.getItem('_errorMessage') ? (window.localStorage.getItem('_errorMessage')) : '')
	const showModal = (window.localStorage.getItem('_showModal') == 'false') && (selected_role != null) ? false : true

	if (loading) {
		return (
			<div>
				<section className="section gray-bg">
					<div className="grid-x align-center">
					<div className="small-12 medium-10 large-8 cell">

					<div className="text-center white-text">
						<h3>Loading roles...</h3>
						<h5 className="loading-text">Loading available roles...</h5>
						<p></p>
					</div>

					</div>
					</div>
				</section>
			</div>)
	}
	
	return (
		<div>
		<Modal classNames={{ modal: 'small-modal' }} open={showModal} onClose={this.onCloseModal}>
          <h2 className="reveal-title">{errorMessage}</h2> 
          
          <ErrorMessage message={errorMessage} flag={errorMessage === 'Loginname duplicated'} token={publicToken} />
          
          <div className="clearfix"></div>
          <button className="button float-left" onClick={this.onCloseModal}>Close</button>
    	</Modal>
		<form onSubmit={handleSubmit(this.submit)} className="checking-roles-form">

			<section className="section gray-bg">
				<div className="grid-x align-center">
				<div className="small-12 medium-10 large-8 cell">

				<div className="text-center heading">
					<h3>Please select the role(s) below</h3>
					<p>The following roles match your gender and age range</p>
					<br/>
					<br/>
				</div>

				<CheckboxGroup 
					className="styled-checkbox" 
					name="roles" 
					options={available_roles}
					selected_role={selected_role}
					validate={[validate.roles]} />

				</div>
				</div>
			</section>

			<section className="section">
				<div className="grid-x align-center">
					<div className="small-12 cell text-center">
						
						{
	            previousPage &&
	            <button 
	              className="button primary previous" 
	              type="button" 
	              onClick={previousPage} >Previous</button>
	          }

	          {
	            nextPage 
	            ? <button className="button primary next" type="submit" disabled={(pristine || submitting) && selected_role != null && selected_role.length == 0}>Next</button>
	            : <button className="button primary" 
	                type="submit" 
	                disabled={pristine || submitting}>
	                  {submitting ? 'Submitting you checking...' : 'Submit' }
	              </button>
	          }

					</div>
				</div>
			</section>
		</form>
		</div>
	)
}
}


export default reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(RolesPage)




// WEBPACK FOOTER //
// ./src/components/Roles.js